export const additionalSounds = [
    {
        src: "sounds/soundBee2.mp3",
        id: "buzz",
    },
];
